import { UrlSegment } from "@angular/router";

export class ProductMatcher {

  /*
    match a url that contains:
     - lowercase word characters (one or many) 
     - digits (one or many)
     - '-' characters (one or many)
     - '_' characters (one or many)
     - ends with .html

    example:
     - eight-days-a-week-herren-abc123.html
     - eight-days-a-week-herren.html
     - eight_days_a_week_herren.html
     - ansa.html
  */

  private static productSlugIndex = 0;

  public static match(url : UrlSegment[]) {
    if (url.length === (this.productSlugIndex + 1) && url[this.productSlugIndex] && url[this.productSlugIndex].path.match(/^([\w]|-|_|[\d])+.html$/gm)) {
      return {
        consumed: url,
        posParams: {
          productSlug: new UrlSegment(url[this.productSlugIndex].path.slice(0, -5), {})
        }
      };
    }

    return null;
  }

}